<template>
  <div :class="{
    content: true,
  }">
    <div class="addOfferLayout">
      <div class="container-alb">
        <table width="95%" align="center" cellpadding="10" cellspacing="0">
          <tr>
            <td align="top" rowspan="11">
              <div class="uploadImageDiv">

                <img  class="membership-user border-round" :src="
                  this.getImagePath() +
                  'users/user_' +
                  user.person.id +
                  '.png'
                " @error="($event.target.src = require('@/assets/images/offer_0.svg'))" />

                <br />
                <div>
                  {{ person.first_name + " " + person.last_name }}
                </div>
              </div>
            </td>
            <td align="left">
              <small>{{ $t("lastNameLabel") }}</small>
              <br />
              <input type="text" v-model="person.last_name" class="formedituser" />
            </td>
            <td align="left">
              <small>{{ $t("firstNameLabel") }}</small>
              <br />
              <input type="text" v-model="person.first_name" class="formedituser" />
            </td>
          </tr>
          <!-- <tr>
            <td align="left" colspan="2">
              <small>{{ $t("companyLabel") }}</small>
              <br />
              <input type="text" v-model="user.companies[0].name" class="formedituser" />
            </td>
          </tr> -->

          <tr>
            <td align="left">
              {{ $t("mobilePhoneLabel") }}
              <!-- // radio button for offer type -->
              <input type="text" class="formedituser" v-model="person.mobile_phone" :style="validateMobileClass"
                required />
            </td>
            <td align="left">
              <small>{{ $t("emailLabel") }}</small>
              <br />
              <input type="text" class="formedituser" v-model="person.email" :style="validateEmailClass" required />
            </td>
          </tr>
          <!-- <tr>
            <td align="left">
              <small>{{ $t("websiteLabel") }}</small>
              <br />
              <input v-if="isUserAdmin(user)" type="text" v-model="user.person.website" class="formedituser" />
              <input v-else type="text" v-model="user.person.website" disabled class="formedituser" />
            </td>
            <td align="left">
              <small>{{ $t("roleCompanyLabel") }}</small>
              <br />
              <select v-model="user.person.functionId" class="w-100">
                <option v-for="(entry, index) in functions" :key="index" :value="entry.code">
                  {{ entry.name }}
                </option>
              </select>
              <-- <input type="text" v-model="user.person.function" class="formedituser" /> --
            </td>
          </tr> -->
          <tr>
            <td>
              <a class="button-all button-orange" @click="submitDetails()">{{
                $t("saveChangesLabel")
              }}</a>&nbsp;&nbsp;&nbsp;&nbsp;
            </td>
            <td>
              <a class="resetButton culoare-11" @click="showModalPopup('modal_popup_actionRequest', true)">{{
                $t("deleteAccountLabel")
              }}</a>
            </td>
          </tr>
        </table>
      </div>
      <div class="margin-left-25">
        <div class="container-alb padding-15 home-wrapper scroll-window">
          <table>
            <tr>
              <td>
                <h5>{{ $t("newsTitle") }}</h5>
              </td>
              <td>
                <!-- @click="seeAllNews()" -->
                <a class="culoare-11 resetButton" target="_blank"
                  href="https://companie.upromania.ro/media/ultimele-noutati/">{{
                    $t("seeAllButton")
                  }}</a>
              </td>
            </tr>
            <!-- <tr v-for="(entry, index) in news" :key="index">
              <td colspan="2">
                <p class="news-date">
                  {{ entry.date }}
                </p>
                <a class="resetButton" :href="entry.link" target="_blank">
                  {{ entry.title }}
                </a>
                <br />
              </td>
            </tr> -->
          </table>
        </div>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.personsError !== null">
          <br />
          <p v-html="$t('error_' + this.personsError.code)"></p>
        </div>
        <div v-else>
          <br />
          <p>{{ $t("personModifySuccess") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpServiceCustomer from "@/http/http-customer.js";
import validator from "@/plugins/fieldValidation";
import Cookies from "js-cookie";

export default {
  props: {
    person: Object,
  },
  data() {
    return {
      user: null,
      personsError: null,
      selectedOffer: null,
    };
  },
  methods: {
    submitDetails() {
      // // this.showModalPopup("modal_popup_loading", true);
      httpServiceCustomer.customerService
        .updatePersonInfo(this.user.id, this.person, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          this.personsError = { code: error.response.code };
          // // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        })
        .then((response) => {
          if (response.status == 200) {
            this.personsError = null;
          } else {
            this.personsError = {
              code: response.data.code,
              description: "Error adding offer",
            };
          }
          // // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    // get modify log details
  },
  computed: {
    validateEmailClass() {
      return this.person.email === ""
        ? ""
        : validator.validateEmail(this.person.email)
          ? ""
          : "outline-color: #ff0000a6; ";
    },
    validateMobileClass() {
      return this.person.mobile_phone === ""
        ? ""
        : validator.validateMobilePhone(this.person.mobile_phone)
          ? ""
          : "outline-color: #ff0000a6; ";
    },
  },
  created() {
    this.user = this.getUser();
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css">

</style>
<style scoped>
.flex-center {
  display: flex;
  align-items: center;
}

.clear-none {
  clear: none;
}

.beneficary-details-page .left {
  display: inline-block;
  width: 50%;
}

.beneficary-details-page .right {
  display: inline-block;
  width: 50%;
}

@media (max-width: 1003px) {
  .beneficary-details-page {
    width: 95%;
    margin: 0 auto;
  }
}
</style>
